import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';

/* List of Promotions created by a Partner */
export var getPromotions = function getPromotions(mpacBaseUrl, partnerId, searchParams) {
  var params = new URLSearchParams(omitBy(searchParams, isEmpty));
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/paged?").concat(params.toString())).then(function (response) {
    return response.json();
  });
};
/* Create Promotion by a Partner*/

export var createPromotion = function createPromotion(mpacBaseUrl, partnerId, promotion) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions"), {
    method: 'POST',
    body: JSON.stringify(promotion),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    return response.json();
  });
};
/* Update Promotion created by a Partner*/

export var updatePromotion = function updatePromotion(mpacBaseUrl, partnerId, promotionId, promotion) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId), {
    method: 'PATCH',
    body: JSON.stringify(promotion),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    return response.json();
  });
};
/* Promotion Details created by a Partner*/

export var getPromotionDetails = function getPromotionDetails(mpacBaseUrl, partnerId, promotionId) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId)).then(function (response) {
    return response.json();
  });
};
/* List of Promotion Codes created by a Partner*/

export var getPromotionCodes = function getPromotionCodes(mpacBaseUrl, partnerId, promotionId) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/codes")).then(function (response) {
    return response.json();
  }).then(function (response) {
    return response.codes;
  });
};
/* Create Promotion Code created by a Partner*/

export var createPromotionCode = function createPromotionCode(mpacBaseUrl, partnerId, promotionId) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/codes"), {
    method: 'POST'
  }).then(function (response) {
    return response.json();
  });
};
/* Delete Promotion Code created by a Partner*/

export var deletePromotionCode = function deletePromotionCode(mpacBaseUrl, partnerId, promotionId, promotionCode) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/codes/").concat(promotionCode), {
    method: 'DELETE'
  }).then(function (response) {
    return response.json();
  });
}; // End promotion created by partner

export var endPromotion = function endPromotion(mpacBaseUrl, partnerId, promotionId) {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/end"), {
    method: 'PATCH'
  }).then(function (response) {
    return response.json();
  });
};